<script setup>
import { onMounted, ref } from "vue";
import { useGlobalStore } from "@stores/global.js";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { prefersReducedMotion } from "@utils/prefersReducedMotion";

const props = defineProps({
	images: {
		type: Array,
		default: () => [
			"https://images.unsplash.com/photo-1625982503303-5a3e849260a7?q=80&w=3118&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
			"https://images.unsplash.com/photo-1625982503303-5a3e849260a7?q=80&w=3118&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
		],
	},
	className: {
		type: String,
		default: "",
	},
});

const global = useGlobalStore();
const section = ref(null);

onMounted(() => {
	global.setTheme(null, null, null);

	if (prefersReducedMotion()) return;

	gsap.registerPlugin(ScrollTrigger);

	const scrollTrigger = ScrollTrigger.create({
		trigger: section.value,
		start: "top 80%",
		end: "bottom 20%",
		toggleActions: "play none none none",
	});

	gsap.utils.toArray("[animate-image]").forEach((el, index) => {
		gsap.from(el, {
			y: 24,
			opacity: 0,
			duration: 0.8,
			delay: index * 0.2,
			ease: "power2.out",
			scrollTrigger: scrollTrigger,
		});
	});
});
</script>

<template>
	<section :class="['py-8 lg:py-80', className]" ref="section">
		<div class="container">
			<div class="grid gap-8 lg:grid-cols-2">
				<img
					v-for="(image, index) in images"
					:key="index"
					animate-image
					class="aspect-video w-full rounded-lg object-cover"
					:src="image"
					:alt="`Image ${index + 1}`"
				/>
			</div>
		</div>
	</section>
</template>
